var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-transition animation-container children-absolute"},[_c('transition',{attrs:{"name":_vm.transitionName},on:{"before-enter":_vm.onBeforeEnter,"after-leave":_vm.onAfterLeave}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }